import { render, staticRenderFns } from "./JokesList.vue?vue&type=template&id=2ac687ae&scoped=true&"
import script from "./JokesList.vue?vue&type=script&lang=js&"
export * from "./JokesList.vue?vue&type=script&lang=js&"
import style0 from "./JokesList.vue?vue&type=style&index=0&id=2ac687ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac687ae",
  null
  
)

export default component.exports